<template>
    <div>
        <form @submit.prevent="changePassword" class="md-layout">
            <md-field>
                <label>{{ $t("message.password") }}</label>
                <md-input
                    v-model="resetPasswordFields.newPassword"
                    v-validate="'required|min:6'"
                    type="password"
                    :name="$t('message.newPassword')"
                    ref="password"
                />
            </md-field>
            <md-field>
                <label>{{ $t("message.passwordRepeat") }}</label>
                <md-input
                    v-validate="'required|confirmed:password'"
                    :name="$t('message.passwordRepeat')"
                    type="password"
                    v-model="resetPasswordFields.newPasswordRepeat"
                />
            </md-field>

            <md-button class="md-primary" type="submit" :disabled="loading">
                <md-progress-spinner
                    :md-diameter="20"
                    v-if="loading"
                    class="md-accent"
                    md-mode="indeterminate"
                ></md-progress-spinner>
                <span v-else>{{ $t("message.changePassword") }}</span>
            </md-button>
        </form>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "ResetPassword",
    data() {
        return {
            resetPasswordFields: {
                newPassword: "",
                newPasswordRepeat: "",
            },
            loading: false,
            recaptchaSiteKey: "6Lf7tt4sAAAAAEa_UXb1pZoDCGuPRgooOun8nFiR",
        };
    },
    props: {
        onCompleted: Function,
        default: () => {},
    },
    mounted() {
        if (this.recaptchaSiteKey) {
            const script = document.createElement("script");
            script.src = "https://www.google.com/recaptcha/api.js?render=" + this.recaptchaSiteKey;
            document.head.appendChild(script);
        }
    },
    methods: {
        ...mapActions({
            resetPassword: "auth/resetPassword",
        }),
        getRecaptchaToken() {
            if (!this.recaptchaSiteKey || !window.grecaptcha) {
                return Promise.resolve(null);
            }
            return new Promise((resolve) => {
                window.grecaptcha.ready(() => {
                    window.grecaptcha.execute(this.recaptchaSiteKey, { action: "reset_password" }).then(resolve);
                });
            });
        },
        changePassword() {
            this.$validator.validateAll().then((response) => {
                if (response) {
                    this.loading = true;
                    this.getRecaptchaToken().then((recaptchaToken) => {
                    const payload = {
                        password: this.resetPasswordFields.newPassword,
                        token: this.$route.query.ptoken,
                        isPasswordless: true,
                        email: this.$route.query.email,
                        recaptchaToken: recaptchaToken,
                    };
                    this.resetPassword(payload)
                        .then((res) => {
                            this.onCompleted();
                            this.$router.push("/");
                        })
                        .catch((err) => {
                            const errMsg =
                                err.response && err.response.data && err.response.data.localizedMessages
                                    ? err.response.data.localizedMessages[this.$i18n.locale]
                                    : err.message;
                            this.$bvToast.toast(errMsg, {
                                title: this.$t("message.error"),
                                variant: "danger",
                                solid: true,
                            });
                        })
                        .finally(() => (this.loading = false));
                    });
                }
            });
        },
    },
};
</script>

<style scoped></style>
